import { createRouter, createWebHashHistory } from "vue-router";
import Layout from "@/components/Layout.vue";
const routes = [
  // {
  //   path: "/activity",
  //   name: "Activity",
  //   component: () =>
  //     import(/* webpackChunkName: "Activity" */ "@/views/Activity.vue"),
  // },
  {
    path: "/",
    component: Layout,
    hidden: true,
    redirect: "noredirect",
    children: [
      {
        path: "/activity",
        component: () => import("@/views/Activity.vue"),
        name: "Activity",
        meta: { title: "网络评审报名", icon: "user" },
      },
      {
        path: "/certificate",
        component: () => import("@/views/Certificate.vue"),
        name: "Certificate",
        meta: { title: "证书", icon: "user" },
      },
      {
        path: "/overview",
        component: () => import("@/views/OverView.vue"),
        name: "OverView",
        meta: { title: "参赛选手总览", icon: "user" },
      },
      {
        path: "/leaderApply",
        component: () => import("@/views/LeaderApply.vue"),
        name: "LeaderApply",
        meta: { title: "院校领队申报", icon: "user" },
      },
      {
        path: "/personalInfo",
        component: () => import("@/views/UserInfo.vue"),
        name: "PersonalInfo",
        meta: { title: "个人信息", icon: "user" },
      },
    ],
  },
  {
    path: "/review",
    component: () => import("@/views/Review.vue"),
    name: "Review",
    meta: { title: "网络评审", icon: "user" },
  },
  {
    path: "/loginloading",
    name: "LoginLoading",
    component: () =>
      import(/* webpackChunkName: "LoginLoading" */ "@/views/LoginLoading.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "Login" */ "@/views/Login.vue"),
  },
  {
    path: "/cer",
    name: "cer",
    component: () => import(/* webpackChunkName: "Login" */ "@/views/cer.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  base: process.env.VUE_APP_BASE_URL,
});
router.beforeEach((to, from, next) => {
  console.log("to", to);
  // 判断路由上 query 上是否有redirectRoute参数
  if (to.query.code) {
    next({
      path: "/loginloading",
      query: {
        Referer: to.query.Referer,
        ssocode: to.query.code,
      },
    });
  } else if (to.query.redirectRoute) {
    next("/" + to.query.redirectRoute);
  } else {
    next();
  }
});

export default router;
